import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/guofeng2022/banner.jpg'
import navColor from '../../assets/guofeng2022/nav/color.jpg'
import navBg from '../../assets/guofeng2022/nav/nav_bg.png'
import navBgFixed from '../../assets/guofeng2022/nav/nav_bg_fixed.png'

import far1 from '../../assets/guofeng2022/nav/far1.png'
import far1_active from '../../assets/guofeng2022/nav/far1_active.png'
import far2 from '../../assets/guofeng2022/nav/far2.png'
import far2_active from '../../assets/guofeng2022/nav/far2_active.png'

import son1 from '../../assets/guofeng2022/nav/son1.png'
import son1_active from '../../assets/guofeng2022/nav/son1_active.png'
import son2 from '../../assets/guofeng2022/nav/son2.png'
import son2_active from '../../assets/guofeng2022/nav/son2_active.png'
import son3 from '../../assets/guofeng2022/nav/son3.png'
import son3_active from '../../assets/guofeng2022/nav/son3_active.png'
import son4 from '../../assets/guofeng2022/nav/son4.png'
import son4_active from '../../assets/guofeng2022/nav/son4_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(130),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(130),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(130),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    paddingTop: calcRemFn(20),
    marginLeft: calcRemFn(84.5),
    width: calcRemFn(38),
    flexWrap: 'wrap'
  },
  topBtnBaseCss: {
    padding: `${calcRemFn(4)} 0 0`,
    width: calcRemFn(37.5),
    height: calcRemFn(37.5)
  },
  bottomBtnLayout: {
    width: calcRemFn(160),
    justifyContent: 'flex-start',
    padding: `${calcRemFn(30)} 0 0 ${calcRemFn(50)}`,
  },
  bottomBtnBaseCss: {
    padding: `${calcRemFn(8)} ${calcRemFn(10)} 0`,
    width: calcRemFn(27.5),
    height: calcRemFn(56)
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son4,
        img_actived: son4_active
      }
    ],
  }
}

const pictureList = [
  {
    key: '1_1',
    pid: 102828,
    picNum: 3,
  },
  {
    key: '1_1',
    pid: 102829,
    picNum: 3,
    startIndex: 3,
  },
  {
    key: '1_2',
    pid: 102828,
    picNum: 3
  },
  {
    key: '1_3',
    pid: 102828,
    picNum: 3
  },
  {
    key: '2_1',
    pid: 102828,
    picNum: 4,
  },
  {
    key: '2_1',
    pid: 102829,
    picNum: 3,
    startIndex: 4,
  }
]

function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum = 2, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/guofeng2022/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)


const topDiff = {
  firstSon: '_i1',
  top1_i1: 85,
  top2_i1: 85,
}

export default {
  title: '大师国风',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
